export default __webpack_public_path__ + "static/media/p60.7565545c.jpg";